import toString from 'lodash/toString';
// Import Actions
import {
  FETCH_REALEVENTS,
  FETCHING_REALEVENTS,
  APPLY_FILTERS,
  APPLYING_FILTERS,
  FETCHING_REALEVENT_FILTERS,
  FETCH_REALEVENT_FILTERS,
  LOAD_REALEVENT_PAGE,
  LOADING_REALEVENT_PAGE,
  OPEN_FILTERS_MODAL,
  CLOSE_FILTERS_MODAL,
  SET_REALEVENT_SEARCH_PAGE_FILTERS,
  SET_REALEVENT_SORT_FILTERS,
  SET_REALEVENT_FILTERS,
  SET_MIN_MAX_REALEVENT_FILTER_ITEM,
  SET_REALEVENT_SEARCH_APPLIED_FILTERS,
  SET_REALEVENT_FILTER_ITEM,
  SET_REALEVENT_FILTER,
  FETCH_MORE_REALEVENTS,
} from '../actions/RealEventActions';

// Initial State
const initialState = {
  isBaseFiltersLoaded: false,
  list: [],
  realeventSearchFilters: [],
  sortFilters: [],
  realeventSearchParams: [],
  searchValidators: {},
  pageNum: 1,
  pageSize: 9,
  totalCount: 0,
  appliedFilters: {},
  isFilterModalOpen: false,
  isLoadingListPage: false,
  isFetchingRealEvents: false,
  isFetchingFilters: false,
  isLoadingRealEventPage: false,
  realevent: {},
  similarRealEvents: [],
  images: [],
};

const RealEventReducers = (state = initialState, action) => {
  switch (action.type) {

    case FETCH_MORE_REALEVENTS:
      let prevList = state.list;
      let newEventList = [];
      if(action.list && action.list.length > 0) {
        newEventList = prevList.concat(action.list);
        return {
          ...state,
          isFetchingRealEvents: action.isFetchingRealEvents,
          list: newEventList,
          totalCount: action.totalCount,
          pageNum: action.pageNum,
        };

      } else {
        newEventList = prevList;
        return {
          ...state,
          isFetchingRealEvents: state.isFetchingRealEvents,
          list: newEventList,
          totalCount: state.totalCount,
          pageNum: state.pageNum,
        };
      }

    case FETCHING_REALEVENT_FILTERS:
      return {
        ...state,
        isFetchingFilters: action.isFetchingFilters,
      };

    case FETCH_REALEVENT_FILTERS:
      return {
        ...state,
        isBaseFiltersLoaded: action.isBaseFiltersLoaded,
        isFetchingFilters: action.isFetchingFilters,
        occasionFilters: action.occasionFilters,
        cityFilters: action.cityFilters,
        eventTimeFilters: action.eventTimeFilters,
        colorFilters: action.colorFilters,
        subAreaFilters: action.subAreaFilters,
      };

    case FETCHING_REALEVENTS:
      return {
        ...state,
        isFetchingRealEvents: action.isFetchingRealEvents,
      };

    case FETCH_REALEVENTS:
      return {
        ...state,
        isFetchingRealEvents: action.isFetchingRealEvents,
        list: action.list,
        totalCount: action.totalCount,
        pageNum: action.pageNum,
        searchValidators: action.searchValidators,
      };

    case SET_REALEVENT_FILTERS:
      let sortFilters = action.sortFilters;
      if (sortFilters && sortFilters.length > 0) {
        sortFilters = sortFilters.map(item => {
          item.isSelected = false;
          return item;
        });
        sortFilters[0].isSelected = true;
      }
      return {
        ...state,
        realeventSearchFilters: action.realeventSearchFilters,
        sortFilters: sortFilters,
        isBaseFiltersLoaded: action.isBaseFiltersLoaded,
        realeventSearchParams: action.realeventSearchParams,
      };

    case APPLY_FILTERS:
      return {
        ...state,
        isFilterApplied: action.isFilterApplied,
      };

    case APPLYING_FILTERS:
      return {
        ...state,
        list: action.list,
        pageNum: action.pageNum,
      };

    case OPEN_FILTERS_MODAL:
      return {
        ...state,
        isFilterModalOpen: action.isFilterModalOpen,
        isFetchingRealEvents: action.isFetchingRealEvents,
      };

    case CLOSE_FILTERS_MODAL:
      return {
        ...state,
        isFilterModalOpen: action.isFilterModalOpen,
      };

    case LOADING_REALEVENT_PAGE:
      return {
        ...state,
        isLoadingRealEventPage: action.isLoadingRealEventPage,
      };

    case LOAD_REALEVENT_PAGE:
      return {
        ...state,
        isLoadingRealEventPage: action.isLoadingRealEventPage,
        realevent: action.realevent,
        images: action.images,
        similarRealEvents: action.similarRealEvents,
      };

    case SET_REALEVENT_SEARCH_APPLIED_FILTERS:
      return {
        ...state,
        appliedFilters: action.appliedFilters,
      };

      case SET_REALEVENT_SORT_FILTERS:
      return {
        ...state,
        sortFilters: action.sortFilters,
      };

    case SET_REALEVENT_SEARCH_PAGE_FILTERS:
      return {
        ...state,
        realeventSearchFilters: action.realeventSearchFilters,
      };

    case SET_MIN_MAX_REALEVENT_FILTER_ITEM:
      let realeventMinFilters = state.realeventSearchFilters.map(filterItem => {
        if (filterItem.minQueryParamName === action.paramName) {
          filterItem.minParams = filterItem.minParams.map(item => {
            item.isSelected = (toString(item.value) === toString(action.value));
            return item;
          });
        } else if(filterItem.maxQueryParamName === action.paramName){
          filterItem.maxParams = filterItem.maxParams.map(item => {
            item.isSelected = (toString(item.value) === toString(action.value));
            return item;
          });
        }
        return filterItem;
      });
      return {
        ...state,
        realeventSearchFilters: realeventMinFilters,
      };

    case SET_REALEVENT_FILTER_ITEM:
      let realeventFilters = state.realeventSearchFilters.map(filterItem => {
        if (filterItem.queryParamName === action.paramName) {
          filterItem.params = filterItem.params.map(item => {
            let checkvalue ;
            if(action.paramName === 'colors'){
              checkvalue = item.label;
            } else {
              checkvalue = item.value;
            }
            item.isSelected = (toString(checkvalue) === toString(action.value));
            return item;
          });
        }
        return filterItem;
      });
      return {
        ...state,
        realeventSearchFilters: realeventFilters,
      };

    case SET_REALEVENT_FILTER:
      let filters = state.realeventSearchFilters.map(filterItem => {
        if (filterItem.queryParamName === action.paramName) {
          filterItem.params = filterItem.params.map(item => {
            let checkvalue ;
            if(action.paramName === 'colors'){
              checkvalue = item.label;
            } else {
              checkvalue = item.value;
            }
            if (toString(checkvalue) === toString(action.value)) {
              item.isSelected = action.isSelected;
            }
            return item;
          });
        }
        return filterItem;
      });
      return {
        ...state,
        realeventSearchFilters: filters,
      };

    default:
      return state;
  }
};
export const getRealEventSearchValidators = state => state.realevents.searchValidators;
export const getRealEventAppliedFilters = state => state.realevents.appliedFilters;
export const getRealEventsList = state => state.realevents.list;
export const getFilterModalOpenState = state => state.realevents.isFilterModalOpen;
export const getFilterAppliedState  = state => state.realevents.isFilterApplied;
export const getFetchingRealEventsState  = state => state.realevents.isFetchingRealEvents;
export const getLoadingListPageState = state => state.realevents.isLoadingListPage;
export const getRealEventFiltersLoadedState = state => state.realevents.isBaseFiltersLoaded;
export const getRealEventPageNum = state => state.realevents.pageNum;
export const getRealEventPageSize = state => state.realevents.pageSize;
export const getRealEventTotalCount = state => state.realevents.totalCount;
export const getRealEventSearchParams= state => state.realevents.searchParams;
export const getRealEventSortingOptions = state => state.realevents.sortFilters;
export const getRealEventFilters = state => state.realevents.realeventSearchFilters;

// RealEventPage
export const getRealEvent = state => state.realevents.realevent;
export const getRealEventImages = state => state.realevents.images;
export const getSimilarEvents = state => state.realevents.similarRealEvents;
export const getRealEventPageLoadingState = state => state.realevents.isLoadingRealEventPage;

export default RealEventReducers;
